import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const useRouterProps = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const history = useMemo(() => ({
    push: (to, state) => navigate(to, { state }),
    replace: (to, state) => navigate(to, { replace: true, state }),
    goBack: () => navigate(-1),
  }), [navigate]);

  return {
    history,
    location,
    match: { params },
  };
};

export const RouteComponent = ({ Component, ...props }) => {
  const routerProps = useRouterProps();

  return <Component {...props} {...routerProps} />;
};

export const withRouter = (Component) => {
  const WithRouter = (props) => <RouteComponent Component={Component} {...props} />;
  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  return WithRouter;
};
